import axios from 'axios';
import { JSON_URL } from "../../config/RouterLink";

//Datos iniciales

const dataInicial = {
    error: {
        mensaje: null,
        estatus: null
    },
    acusePostulacion: null, // data
    terminaAcusePostulacion: null, //termina
    loadingAcusePostulacion: false, //Loading
}

//Constantes

//URL's API
const URL_API_DESCARGAR_ACUSE_POSTULACION = '/ConcursoPublico/api/postulaciones/generaAcusePostulacion';

//Tipos Acciones 
const SET_LOADING_ACUSE_POSTULACION = 'SET_LOADING_ACUSE_POSTULACION';
const CLEAN_LOADING_ACUSE_POSTULACION = 'CLEAN_LOADING_ACUSE_POSTULACION';

const SET_ESTATUS_PETICION_ACUSE_POSTULACION = 'SET_ESTATUS_PETICION_ACUSE_POSTULACION';

const SET_ACUSE_POSTULACION = "SET_ACUSE_POSTULACION";
const VACIAR_STORE_ACUSE_POSTULACION = "VACIAR_STORE_ACUSE_POSTULACION";

//Reducer
export default function AcusePostulacionReducer(state = dataInicial, action) {
    switch (action.type) {
        case SET_ESTATUS_PETICION_ACUSE_POSTULACION:
            return { 
                    ...state, 
                    terminaAcusePostulacion: action.payload.bandera, 
                    error: action.payload.error 
            };
        case SET_LOADING_ACUSE_POSTULACION:
            return  { 
                    ...state, 
                    loadingAcusePostulacion: action.payload.bandera 
            };
        case CLEAN_LOADING_ACUSE_POSTULACION:
            return  { 
                    ...state, 
                    loadingAcusePostulacion: false 
            };
        case SET_ACUSE_POSTULACION:
            return {
                ...state, acusePostulacion: action.dataReporte
            }
        case VACIAR_STORE_ACUSE_POSTULACION:
            return dataInicial

        default: return state;
    }
};

//Acciones - Interacción con el Store
export const setEstatusPeticionAcuse = (payload) => async (dispatch) => {
    dispatch({
        type: SET_ESTATUS_PETICION_ACUSE_POSTULACION,
        payload
    });
}; 

export const setDataAcuse = (dataReporte) => async (dispatch) => {
    dispatch({
        type: SET_ACUSE_POSTULACION,
        dataReporte,
    })
}

export const vaciarStoreAcuse = () => async (dispatch) => {
    dispatch({
        type: VACIAR_STORE_ACUSE_POSTULACION,
    })
};

export const limpiarLoadingAcuse = () => async (dispatch) => {
    dispatch({
        type: CLEAN_LOADING_ACUSE_POSTULACION
    })
};


//Acciones - Llamadas a Servicios

export const descargarAcusePostulacion = (parametros) => async (dispatch, getState) => {
    const { accessToken } = getState().usuarioLogin;
    try {
        dispatch({ type: SET_LOADING_ACUSE_POSTULACION, payload: { bandera: true } });
        
        const urls = await axios(window.location.origin + JSON_URL);

        const reporte = await axios({
            method: 'post',
            url: `${urls.data.urlServer + URL_API_DESCARGAR_ACUSE_POSTULACION}`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            },
            data: { ...parametros }
        });

        dispatch(setDataAcuse(reporte.data));
        dispatch({ type: SET_LOADING_ACUSE_POSTULACION, payload: { bandera: false } });
        dispatch(setEstatusPeticionAcuse({ bandera: true, error: { mensaje: null, estatus: null } }));
    }
    catch (error) {
        dispatch({ type: SET_LOADING_ACUSE_POSTULACION, payload: {  bandera: false } });

        if (!error.response) {
            dispatch(setEstatusPeticionAcuse({  bandera: false, error: { mensaje: "Ha ocurrido un problema con el servicio, por favor intenta más tarde." } }));
        } else {
            dispatch(setEstatusPeticionAcuse({  bandera: false, error: error.response.data }));
        }
    }
};

